import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { TopBar } from './components/TopBar';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { SevenIslandsPage } from './pages/SevenIslandsPage';
import { BoathousePage } from './pages/BoathousePage';
import { ContactPage } from './pages/ContactPage';
import { ComingSoonPage } from './pages/ComingSoonPage';
export function App() {
  return <Router data-id="element-0" data-mp="2wiyxgtcwlvc7">
      <ScrollToTop data-id="element-1" data-mp="2wj8g1vvmd07v" />
      <div className="flex flex-col min-h-screen" data-id="element-2" data-mp="2whx9joashed2">
        <TopBar data-id="element-3" data-mp="28tmg367fagyt" />
        <Navbar data-id="element-4" data-mp="28t4lee0esat0" />
        <main className="flex-grow" data-id="element-5" data-mp="28sl3gxardmez">
          <Routes data-id="element-6" data-mp="23vkwmk634fmt">
            <Route path="/" element={<HomePage data-id="element-8" data-mp="23ujlkfp2jt53" />} data-id="element-7" data-mp="23w4fc33k781w" />
            <Route path="/about" element={<AboutPage data-id="element-10" data-mp="3ik7eyd5x05p2" />} data-id="element-9" data-mp="23t8g8bfz6dbv" />
            <Route path="/projects" element={<ProjectsPage data-id="element-12" data-mp="3ijpet5g4t7bv" />} data-id="element-11" data-mp="3iiwfgpji5k3r" />
            <Route path="/projects/7-islands" element={<SevenIslandsPage data-id="element-14" data-mp="3mk852v2dm5by" />} data-id="element-13" data-mp="3mlawr57iwbsx" />
            <Route path="/projects/boathouse" element={<BoathousePage data-id="element-16" data-mp="3rbzomln47asl" />} data-id="element-15" data-mp="3mj6ipufwtwex" />
            <Route path="/services" element={<ServicesPage data-id="element-18" data-mp="5yjsutqtdfe" />} data-id="element-17" data-mp="3rcsulke91w9o" />
            <Route path="/contact" element={<ContactPage data-id="element-20" data-mp="5ghbgghm2z1" />} data-id="element-19" data-mp="680tswt8a8y" />
            <Route path="/portal" element={<ComingSoonPage data-id="element-22" data-mp="2zllijblcf2rh" />} data-id="element-21" data-mp="7sxbo2oq39g" />
          </Routes>
        </main>
        <Footer data-id="element-23" data-mp="2zng2amkvootz" />
      </div>
    </Router>;
}